import { options } from "@/shared/JWPlayer/config";
import { Video, ContentVideo} from "./styles";
import { useEffect, useRef, useState } from "react";

const VideoLoop = ({videoLoop = "",  titleLocation = "", posterPlayer=false, width = 320, videoLoopFlavors = []}) => {

// const nameCustomEvent = "jwPlayerScriptLoaded";
// const idJwPlayer = "jwPlayerLibraryvideo_home";
// const videoRef = useRef();
// const entityIDdiv= "loop"+videoLoop?.entityId
//   const installPlayerScript = () => {
//     const jwPlayerScript = document.createElement("script");
//     jwPlayerScript.id = idJwPlayer;
//     jwPlayerScript.src = process.env.NEXT_PUBLIC_HOME_JWPLAYER_ID;
//     jwPlayerScript.async = true;
//     jwPlayerScript.onload = () => {
//       document.dispatchEvent(new CustomEvent(nameCustomEvent));
//       initialize();
//     };
//     document.body.appendChild(jwPlayerScript);
//   };


//   const initialize = () => {
//     window.removeEventListener("load", initialize);
//     const player = window.jwplayer(videoRef.current);
//     const optionsPlayer = options.loop ?? {};

//     const playerOpts = {
//       ...( posterPlayer || !videoLoop.videoLoop
//           ? { file: videoLoop.poster,
//               image: `https://cdn.jwplayer.com/v2/media/${videoLoop.entityId}/poster.jpg?width=720`, preload: "metadata"
//             } //Poster loop del video relacionado hecho por jwplayer
//           : { playlist:  videoLoop.url } //Videoloop hecho por el usuario cargado por el usuario
//         ),
//       ...optionsPlayer
//     };
// console.log("videoLoop.postervideoLoop.poster",videoLoop.poster)
//     if (videoRef.current) {
//       player.setup(playerOpts);     
//     }
//   };

 
  // useEffect(() => {
  //   const existingLibraryScript = document.getElementById(idJwPlayer);
  //   if (!existingLibraryScript) {
  //     installPlayerScript();
  //   } else if (window?.jwplayer) {
  //     initialize();
  //   } else {
  //     document.addEventListener(nameCustomEvent, initialize, { once: true });
  //   }    
  // }, []);

  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: "200px" }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible || !videoLoop?.entityId) return;
    let api = `/api/JWP/${videoLoop.entityId}/${width}/true`;
    let hasFlavors = false;
    
    if (videoLoopFlavors.length > 0) {
      const flavor =  videoLoopFlavors.find((f) => f.id === `360p`) || 
                      videoLoopFlavors.find((f) => f.id === "540p") || 
                      videoLoopFlavors.find((f) => f.id === "180p");
      const urlVideo = flavor?.url || null;
      if (urlVideo) {
        const url = new URL(urlVideo);
        const parts = url.pathname.split('/'); 
        const entity = parts[parts.length - 1].replace('.mp4', '');
        api = `/api/JWP/${entity}/${width}/false`;
        hasFlavors = true;
      }
    }
    const fetchVideo = async () => {
      try {
        const response = await fetch(`${api}`);
        const data = await response.json();

        let videoSrc = null;
        if (hasFlavors) {
          const pathname = data?.data ?? null;
          if (pathname) videoSrc = pathname.replace('https://videos-cloudfront.jwpsrv.com/', 'https://videos-jwpsrv.clarin.com/');
        } else {
          const match = data?.data?.match(/\/thumbnails\/([^\-]+)/);
          const id = match ? match[1] : null;
          if (id) videoSrc = `https://videos.clarin.com/thumbnails/${id}-${width}.mp4`;
        }
        setVideoUrl(videoSrc);
      } catch (e) {
        console.error("Error fetching video loop:", e);
      }
    };

    fetchVideo();
  }, [isVisible, videoLoop?.entityId, width]);

  if (!videoLoop?.entityId) return null;

  const poster = `https://cdn.jwplayer.com/v2/media/${videoLoop.entityId}/poster.jpg?width=720`;
  return (
    <ContentVideo
      ref={containerRef}
      className={` ${titleLocation} contentVideo`}
    >
      {!isVisible || !videoUrl ? (
        <picture>
          <img
            className="imagePoster"
            src={poster}
            alt={videoLoop?.videoName}
            style={{ width: "100%" }}
          />
        </picture>
      ) : (
        <video
          src={videoUrl}
          poster={poster}
          onEnded={(e) => {
            e.target.currentTime = 0;
            e.target.play();
          }}
          autoPlay
          loop
          muted
          playsInline
          data-width={width}
        />
      )}

      {videoLoop?.videoName && (
        <p className="epigraphe">{videoLoop.videoName}</p>
      )}
    </ContentVideo>
  );
};

export default VideoLoop;
